import ProfileModel from "../../../Profile/Models/ProfileModel";
import BracketGamePredictionFixturesModel from "./BracketGamePredictionFixturesModel";
import BracketGameTiebreaker from "./BracketGameTiebreaker";

export enum BracketGamePredictionStatusEnum {
  /**
   * ACTIVE Predictions are made.
   */
  ACTIVE = "ACTIVE",
  /**
   * Settled WON all Predictions are correct.
   */
  WON = "WON",
  /**
   * Settled LOST all Prediction are incorrect.
   */
  LOST = "LOST",
  /**
   * Settled PARTIAL_WON (obtained some points) not all Predictions are correct.
   */
  PARTIALLY_WON = "PARTIALLY_WON",
  /**
   * CANCELED Predictions because game was canceled.
   */
  CANCELED = "CANCELED",
}

export default class BracketGamePredictionModel {
  public id: string = "";
  public profileId: string = "";
  public profileModel: ProfileModel | null = null;
  public gameId: string = "";
  public totalPoints: number | null = null;
  public gamePoints: number | null = null;
  public bonusPoints: number | null = null;
  public position: number | null = null;
  public status: BracketGamePredictionStatusEnum =
    BracketGamePredictionStatusEnum.ACTIVE;
  public fixtures: BracketGamePredictionFixturesModel[] = [];
  public tiebreaker: BracketGameTiebreaker = new BracketGameTiebreaker();
  public createdAt: string = "";
  public updatedAt: string = "";
}
